import { useEffect, useState } from "react";
import HeaderSection from "../../components/HeaderSection";
import UserComponent from "../../components/UserComponent";
import UserInfoComponent from "../../components/UserInfoComponent";
import ReminderComponent from "../../components/ReminderComponent";
import TransactionHeader from "../../components/TransactionHeader";
import TransactionComponent from "../../components/TransactionComponent";
import NoData from "../../components/NoData";
import { useWallet } from "../../context/WalletContext";
import { api } from "../../api/client";
import { mapWillForUi } from "../../utils/icons";

export default function AccountPage() {
    const { wallet, isConnected, profile, loading: walletLoading } = useWallet();
    const [wills, setWills] = useState([]);
    const [claims, setClaims] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let cancelled = false;
        async function load() {
            if (!wallet) {
                setWills([]);
                setClaims([]);
                return;
            }
            setLoading(true);
            setError('');
            try {
                const [mine, heir] = await Promise.all([
                    api.getWills({ scope: 'owner' }, wallet),
                    api.getWills({ scope: 'heir' }, wallet),
                ]);
                if (cancelled) return;
                setWills((mine.items || []).map(mapWillForUi));
                setClaims((heir.items || []).map(mapWillForUi));
            } catch (err) {
                if (!cancelled) setError(err.message);
            } finally {
                if (!cancelled) setLoading(false);
            }
        }
        load();
        return () => { cancelled = true; };
    }, [wallet]);

    const empty = !isConnected || (!loading && wills.length === 0 && claims.length === 0);

    return (
        <div className="bg-[#121212] pb-[90px]">
            <HeaderSection account={true} />
            <div className="flex flex-col px-[20px] lg:px-[150px] pt-[100px]">
                {!isConnected && (
                    <div className="mb-8 text-[#FBBF04]">Connect a wallet to load your profile, wills and claims.</div>
                )}
                {error && <div className="mb-8 text-red-400">{error}</div>}
                <div className="flex flex-col 2xl:flex-row w-full gap-[30px]">
                    <UserComponent profile={profile} loading={walletLoading} />
                    <UserInfoComponent profile={profile} />
                    <ReminderComponent profile={profile} />
                </div>
                <div className="flex flex-col mt-10">
                    <p className="text-white text-[35px] font-bold">My Will:</p>
                </div>
            </div>
            <div className="overflow-x-auto">
                <TransactionHeader />
                {loading && <div className="px-[20px] lg:px-[150px] text-gray1 py-6">Loading...</div>}
                {!loading && wills.length > 0 && wills.map((item) => (
                    <div key={`will-${item.id}`}>
                        <TransactionComponent item={item} />
                    </div>
                ))}
                {!loading && wills.length === 0 && (
                    <div className="flex flex-col px-[20px] lg:px-[150px] min-w-[1560px]"><NoData /></div>
                )}

                <div className="flex flex-col px-[20px] lg:px-[150px] ">
                    <div className="flex flex-col mt-10">
                        <p className="text-white text-[35px] font-bold">My Claims:</p>
                    </div>
                </div>
                <TransactionHeader />
                {!loading && claims.length > 0 && claims.map((item) => (
                    <div key={`claim-${item.id}`}>
                        <TransactionComponent item={item} />
                    </div>
                ))}
                {!loading && (empty || claims.length === 0) && (
                    <div className="flex flex-col px-[20px] lg:px-[150px] min-w-[1560px]"><NoData /></div>
                )}
            </div>
        </div>
    );
}
